import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Dropdown,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Form,
  ListGroup,
  Image,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import img1 from "../../../assets/images/small/07.png";
import img2 from "../../../assets/images/small/08.png";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { getToken } from "../../../utils/auth";
import { useNavigate } from "react-router-dom";
import { MdOutlineDone } from "react-icons/md";
import * as moment from "moment";
import useAuth from "../../../utils/useAuth";
import GroupCard from "./Group/GroupCard";
import { useUser } from "../../../Context/UserContext";
import { useTranslation } from "react-i18next";
import { RiCloseCircleFill } from "react-icons/ri";

const GroupDetail = () => {
  useAuth();
  const { userData } = useUser();
  const { t, i18n } = useTranslation();

  const { groupid } = useParams();
  const [show, setShow] = useState(false);
  const [showRequests, setShowRequests] = useState(false);
  const [requests, setRequests] = useState([]);
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const handleClose = () => {
    setShow(false);
    setDescription("");
    setSelectedFile([]);
    setImagePreview([]);
  };
  const handleShow = () => setShow(true);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [groups, setGroups] = useState(null);
  const [groupMember, setGroupMember] = useState(null);
  const [groupLength, setGroupLength] = useState(0);
  const [imagePreview, setImagePreview] = useState([]);

  const handleGroups = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/group/${groupid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setGroups(response.data.data.groupDetails);
      setGroupMember(response.data.data.groupMemberList);
      setGroupLength(response.data.data.numberOfMembers);
      setRequests(response.data.data.groupJoinRequest);
    } catch (error) {
      console.log("Failed Fetching Group", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    handleGroups();
  }, [groupid]);

  const handleJoinRequest = async (groupMemberId, status) => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/group/join-request/${groups?._id}/${groupMemberId}`,
        { status },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowRequests(false);
      handleGroups();
      toast.success(response?.data?.message || "Error handling request");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error handling request");
      console.error(
        "Error handling join request:",
        error?.response?.data?.message
      );
    }
  };

  const profileImage = userData?.profileImageLink
    ? userData?.profileImageLink
    : "/profile.png";

  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };


  // const handleFileInputChange = (event) => {
  //   const files = Array.from(event.target.files);
  //   setSelectedFile(files);
  //   const previews = files.map((file) => URL.createObjectURL(file));
  //   setImagePreview(previews);
  //   toast.success("File selected!");
  // };
  const handleFileInputChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFile(files);
    const filePreviews = files.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video",
    }));
    setImagePreview(filePreviews);
  };
      
  const handleRemove = (index) => {
    const updatedPreviews = imagePreview.filter((_, i) => i !== index);
    const updatedFiles = selectedFile.filter((_, i) => i !== index);
  
    setImagePreview(updatedPreviews);
    setSelectedFile(updatedFiles);
  };
  const [photos, setPhotos] = useState([]);
  // const handlePost = async () => {

  //     if (!description) {
  //         toast.error("Description is required");
  //         return;
  //     }
  //     try {
    // const token = getToken();
  //         const formData = new FormData();
  //         for (let i = 0; i < selectedFile.length; i++) {
  //             formData.append('files', selectedFile[i]);
  //         }

  //         const uploadResponse = await axios.post(
  //             `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
  //             formData,
  //             {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                     'Authorization': `Bearer ${token}`,
  //                 },
  //             }
  //         );
  //         console.log("oath", uploadResponse.data.data)

  //         setPhotos(uploadResponse.data.data)
  //         postPhoto(uploadResponse.data.data);

  //         //   setShow(false);
  //     } catch (error) {
  //         console.log("Failed to create post:", error);
  //         toast.error(error?.uploadResponse?.data?.message || "Failed to Upload Image/Video");
  //     }
  // };
  const handlePost = async () => {
    const maxFileSize = 1 * 1024 * 1024;

    for (let i = 0; i < selectedFile.length; i++) {
      if (selectedFile[i].size > maxFileSize) {
        toast.error("File size must not exceed 1MB");
        return;
      }
    }

    if (!description) {
      toast.error("Description is required");
      return;
    }

    try {
      const token = getToken();
      let uploadedPhotos = [];

      if (selectedFile.length > 0) {
        // Only upload if files are selected
        const formData = new FormData();
        for (let i = 0; i < selectedFile.length; i++) {
          formData.append("files", selectedFile[i]);
        }

        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        uploadedPhotos = uploadResponse.data.data;
      }

      setPhotos(uploadedPhotos);
      postPhoto(uploadedPhotos);
    } catch (error) {
      console.log("Failed to upload image:", error);
      toast.error(
        error?.response?.data?.message || "Failed to Upload Image/Video"
      );
    }
  };

  const postPhoto = async (photoss) => {
    if (!description) {
      toast.error("Description is required");
      return;
    }
    try {
      const token = getToken();
      const postData = {
        description: description,
        photos: photoss,
        groupId: groupid,
        postType: "private",
      };

      const postResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/post`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPost([]);
      handleAllPost(true);
      toast.success("Post created successfully");
      setDescription("");
      setSelectedFile([]);
      setImagePreview([]);
      //   setShow(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log("Failed Posting ", error);
    } finally {
      setShow(false);
    }
  };

  const [post, setPost] = useState([]);
  const handleAllPost = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/post/group-post/${groupid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setPost(response.data.data.allPosts);
    } catch (error) {
      console.log("Failed Fetching Posts", error);
    }
  };

  useEffect(() => {
    handleAllPost();
  }, []);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                <div className="group-info d-flex align-items-center">
                  <div className="me-3">
                    <img
                      className=""
                      src={
                        groups?.uploadedFileLink
                          ? groups?.uploadedFileLink
                          : img1
                      }
                      alt=""
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "100px",
                      }}
                    />
                  </div>
                  <div className="info">
                    <h4
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ marginRight: "10px" }}>
                        {groups?.groupName}
                      </span>
                    </h4>
                    <p className="mb-0" style={{ textTransform: "capitalize" }}>
                      <i className="ri-lock-fill pe-2"></i>
                      {groups?.category} . {groupLength} {t("members")}
                    </p>
                    <p
                      className="mb-0"
                      style={{ textTransform: "capitalize" }}
                      dangerouslySetInnerHTML={{ __html: groups?.description }}
                    ></p>
                  </div>
                </div>
                {groups?.toShow && (
                <div
                  mt-md="0"
                  mt="2"
                  className="group-member d-flex align-items-center"
                >
                  <div className="iq-media-group me-3">
                    {requests.length > 0 && (
                      <Button onClick={() => setShowRequests(true)}>
                        {t("showRequests")}
                      </Button>
                    )}
                    {groups?.qrCodeUrl && (
                      <img
                        src={groups?.qrCodeUrl}
                        style={{
                          width: "80px",
                          height: "80px",
                          marginLeft: "10px",
                        }}
                        onClick={() => handleQrClick(groups)}
                      />
                    )}
                  </div>
                </div>
                )}

              </div>
            </Col>
            {groups?.toShow ? (
              <>
                <Col sm={12}>
                  <Card
                    id="post-modal-data"
                    className="card-block card-stretch card-height"
                  >
                    <div className="card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h4 className="card-title">{t("createPost")}</h4>
                      </div>
                    </div>
                    <Card.Body>
                      <div className="d-flex align-items-center">
                        <div className="user-img">
                          <img
                            src={profileImage}
                            alt="user1"
                            className="avatar-60 rounded-circle"
                          />
                        </div>
                        <form
                          className="post-text ms-3 w-100 "
                          onClick={handleShow}
                        >
                          <input
                            type="text"
                            className="form-control rounded"
                            placeholder="Write something here..."
                            style={{ border: "none" }}
                          />
                        </form>
                      </div>
                    </Card.Body>
                    <Modal
                      size="lg"
                      className="fade"
                      id="post-modal"
                      onHide={handleClose}
                      show={show}
                      style={{ marginTop: "100px", maxHeight:"80vh" }}
                    >
                      <Modal.Header className="d-flex justify-content-between">
                        <Modal.Title id="post-modalLabel">
                          {t("createPost")}
                        </Modal.Title>
                        <Link to="#" className="lh-1" onClick={handleClose}>
                          <span className="material-symbols-outlined">
                            close
                          </span>
                        </Link>
                      </Modal.Header>
                      <Modal.Body>
                        <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                          <li className="col-md-12 mb-3">
                            <Form.Label>
                              {t("description")}{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              name="description"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              className="mb-0 py-2"
                              id=""
                              placeholder="Enter description"
                              required
                            />
                          </li>
                          <li className="col-md-12 mb-3">
                            <Form.Label>
                              {t("image")}{" "}
                              {/* <span style={{ color: "red" }}>*</span>{" "} */}
                            </Form.Label>
                            <label
                              htmlFor="file-input"
                              style={{ cursor: "pointer", width: "100%" }}
                            >
                              <div
                                className="bg-soft-primary rounded p-1 pointer"
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  fontSize: "1.2rem",
                                  position: "relative",
                                  borderRadius: "10px",
                                }}
                              >
                                <input
                                  id="file-input"
                                  type="file"
                                  name="image"
                                  multiple
                                  accept="image/*,video/mp4"
                                  style={{ display: "none" }}
                                  onChange={handleFileInputChange}
                                />
                                <span>
                                  {selectedFile.length > 0 ? (
                                    <MdOutlineDone
                                      style={{ fontSize: "25px" }}
                                    />
                                  ) : (
                                    <i className="fas fa-upload"></i>
                                  )}
                                </span>
                                <p style={{ marginTop: ".5rem" }}>
                                  {t("click_to_select_files")}
                                </p>
                              </div>
                            </label>
                            {imagePreview?.length > 0 && (
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            gap: "10px",
            marginTop: "20px",
            paddingTop:"10px",
          }}
        >
          {imagePreview?.map((preview, index) => (
            <div key={index} style={{ position: "relative" }}>
              {/* Remove Icon */}
              <RiCloseCircleFill
                size={24}
                color="red"
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-8px",
                  cursor: "pointer",
                  zIndex: 10,
                }}
                onClick={() => handleRemove(index)}
              />

              {preview?.type === "image" ? (
                <img
                  src={preview?.url}
                  alt={`Preview ${index + 1}`}
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              ) : (
                <video
                  src={preview?.url}
                  controls
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "10px",
                  }}
                />
              )}
            </div>
          ))}
        </div>
      )}
                            {/* {imagePreview && imagePreview.length > 0 && (
                              <div className="mt-2">
                                {imagePreview.map((preview, index) => (
                                  <img
                                    key={index}
                                    src={preview}
                                    alt={`Selected ${index}`}
                                    style={{
                                      width: "70px",
                                      borderRadius: "10px",
                                      marginBottom: "10px",
                                    }}
                                  />
                                ))}
                              </div>
                            )} */}
                          </li>
                        </ul>

                        <button
                          type="submit"
                          className="btn btn-primary d-block w-100 mt-3"
                          onClick={handlePost}
                        >
                          {t("post")}
                        </button>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      size="sm"
                      className="fade"
                      id="qr-modal"
                      onHide={closeQrPopup}
                      show={qrPopupOpen}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>{t("qr_code")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body className="text-center">
                      <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
          <img
            src={qrImageUrl?.qrCodeUrl}
            alt="QR Code"
            style={{ maxWidth: "100%", height: "auto" }}
          />
          <span>{qrImageUrl?.postUID}</span>
          </div>
                      </Modal.Body>
                      {/* <Modal.Footer>
                        <button
                          className="btn btn-secondary"
                          onClick={closeQrPopup}
                        >
                          {t("close")}
                        </button>
                      </Modal.Footer> */}
                    </Modal>
                  </Card>
                </Col>

                <GroupCard post={post} handleAllPost={handleAllPost} />

                {/* <Col lg="4">
                  <Card>
                    <Card.Header className="card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h4 className="card-title">About</h4>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <ul className="list-inline p-0 m-0">
                        <li className="mb-3">
                          <p
                            className="mb-0"
                            dangerouslySetInnerHTML={{
                              __html: groups?.description,
                            }}
                          ></p>
                        </li>
                        <li className="mb-3">
                          <div className="d-flex">
                            <div className="flex-shrink-0">
                              <i className="material-symbols-outlined">lock</i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 style={{ textTransform: "capitalize" }}>
                                {groups?.category}
                              </h6>
                              <p className="mb-0">
                                Success in slowing economic activity.
                              </p>
                            </div>
                          </div>
                        </li>
                        {groups?.note ? (
                          <li className="mb-3">
                            <div className="d-flex">
                              <div className="flex-shrink-0">
                                <i className="material-symbols-outlined">
                                  group
                                </i>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h6>Note</h6>
                                <p className="mb-0">{groups?.note}</p>
                              </div>
                            </div>
                          </li>
                        ) : (
                          <div></div>
                        )}
                      </ul>
                    </Card.Body>
                  </Card>
                </Col> */}
              </>
            ) : (
              <Col sm={12}>
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                  <div
                    className="card-header  "
                    style={{
                      textAlign: "center",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {t("privateGroupNotice")}
                  </div>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
      <Modal centered show={showRequests} onHide={() => setShowRequests(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("joinRequests")}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "400px", overflow: "auto" }}>
          {requests.length > 0 ? (
            <ListGroup>
              {requests?.map((req) => (
                <ListGroup.Item
                  key={req?._id}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <Image
                      src={req?.userId?.profileImageLink || "/profile.png"}
                      roundedCircle
                      width={40}
                      height={40}
                      className="me-2"
                    />
                    <span>
                      {req?.userId?.firstName} {req?.userId?.lastName}
                    </span>
                  </div>
                  <div>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => handleJoinRequest(req?._id, "accepted")}
                    >
                      {t("accept")}
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      className="ms-2"
                      onClick={() => handleJoinRequest(req?._id, "rejected")}
                    >
                      {t("reject")}
                    </Button>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <p>{t("noJoinRequestsAvailable")}.</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GroupDetail;
